export function socialpopup() {
  const popup = document.createElement('div')
  popup.classList.add('socialpopup')

  function getMultilangString(stringId) {
    let strings = {}
    switch (WC.idLingua) {
      case 2:
        strings.title = 'Follow Asiago.it'
        strings.copy =
          'Follow us on Instagram and become a fan on Facebook to stay up to date on the latest events and news of the Asiago plateau.'
        strings.introNewsletter = null
        strings.emailPlaceholder = null
        strings.introSocial = 'Follow us on our social networks:'
        strings.instagramText = 'Instagram'
        strings.facebookText = 'Facebook'
        break

      case 3:
        strings.title = 'Folgen Sie Asiago.it'
        strings.copy =
          'Folgen Sie uns auf Instagram und werden Sie ein Fan auf Facebook, um über die neuesten Ereignisse und Neuigkeiten des Asiago-Plateaus auf dem Laufenden zu bleiben.'
        strings.introNewsletter = null
        strings.emailPlaceholder = null
        strings.introSocial = 'Folgen Sie uns in unseren sozialen Netzwerken:'
        strings.instagramText = 'Instagram'
        strings.facebookText = 'Facebook'
        break

      default:
        strings.title = 'Segui Asiago.it'
        strings.copy =
          "Iscriviti alla newsletter, seguici su Instagram e diventa un fan su Facebook per rimanere sempre aggiornato sugli ultimi eventi e novità dell'Altopiano di Asiago."
        strings.introNewsletter = 'Iscriviti alla newsletter:'
        strings.emailPlaceholder = 'Indirizzo email'
        strings.introSocial = 'Seguici sui nostri social:'
        strings.instagramText = 'Instagram'
        strings.facebookText = 'Facebook'
        break
    }

    return strings[stringId] || ''
  }

  let season = {
    image: 'estate_thumb.jpg',
    class: 'summer',
  }
  if (WC?.PageVars?.season === 4) {
    season = {
      image: 'inverno_thumb.jpg',
      class: 'winter',
    }
  }

  popup.innerHTML = `
		<script src="https://kit.fontawesome.com/ab5573e198.js" crossorigin="anonymous"></script>
		<div class="sp__popupclose">
			<span class="sp__closecountdown"></span>
			<a class="sp__closeicon material-icons">close</a>
		</div>
		<div class="sp__header">
			<h3 class="sp__title">${getMultilangString('title')}</h3>
			<p class="sp__copy">${getMultilangString('copy')}</p>
		</div>
		<div class="sp__picture" data-season="${season.class}">
			<img class="sp__image" src="/images/socialpopup/${season.image}" alt="Asiago.it">
			<div class="sp__fb-like fb-like" data-href="https://www.facebook.com/Asiago.it" data-layout="button_count" data-action="like" data-size="large" data-share="false" data-width="200"></div>
		</div>
		<ul class="sp__list">
			<li class="sp__item sp__item--intro sp__item--intro-newsletter">
				<p class="sp__intro">${getMultilangString('introNewsletter')}</p>
			</li>
			<li class="sp__item sp__item--newsletter">
				<div class="sp__button">
					<span class="sp__icon material-icons">email</span>
					<input type="email" class="sp__newsletter-email" placeholder="${getMultilangString(
            'emailPlaceholder'
          )}">
					<span class="sp__newsletter-submit material-icons">send</span>
				</div>
			</li>
			<li class="sp__item sp__item--intro sp__item--intro-social">
				<p class="sp__intro">${getMultilangString('introSocial')}</p>
			</li>
			<li class="sp__item sp__item--instagram">
				<a class="sp__button" href="https://www.instagram.com/asiagoit/" target="_blank" rel="noopener">
					<img class="sp__icon sp__icon--svg" src="/images/css/social/instagram-outline-white.svg">
					<span class="sp__text">${getMultilangString('instagramText')}</span>
					<!--<span class="sp__icon material-icons">open_in_new</span>-->
				</a>
			</li>
			<li class="sp__item sp__item--facebook">
				<a class="sp__button" href="https://www.facebook.com/Asiago.it" target="_blank" rel="noopener">
					<img class="sp__icon sp__icon--svg" src="/images/css/social/flogo-outline-white.svg">
					<span class="sp__text">${getMultilangString('facebookText')}</span>
					<!--<span class="sp__icon material-icons">open_in_new</span>-->
				</a>
			</li>
		</ul>
	`

  // Newsletter for IT only
  if (WC.lang !== 'it-IT') {
    popup.querySelector('.sp__item--intro-newsletter').style.display = 'none'
    popup.querySelector('.sp__item--newsletter').style.display = 'none'
  }

  // Newsletter
  const newsletterInput = popup.querySelector('.sp__newsletter-email')
  const newsletterSubmit = popup.querySelector('.sp__newsletter-submit')

  newsletterInput.addEventListener('keyup', popupNewsletterEmailValidity)
  newsletterInput.addEventListener('keydown', popupNewsletterEmailSubmit)
  newsletterSubmit.addEventListener('click', popupSendNewsletter)

  function popupSendNewsletter() {
    const email = newsletterInput.value

    if (popupNewsletterEmailValidity()) {
      window.open(
        `${window.location.protocol}//${
          window.location.host
        }/it/newsletter/?email=${encodeURIComponent(email)}`,
        '_blank'
      )
    } else {
      alert('Indirizzo email non valido')
    }
  }

  function popupNewsletterEmailValidity() {
    if (newsletterInput.checkValidity()) {
      newsletterInput.dataset.validity = 'true'
      return true
    } else {
      newsletterInput.dataset.validity = 'false'
      return false
    }
  }

  function popupNewsletterEmailSubmit(event) {
    if (event.keyCode == 13) {
      popupSendNewsletter()
    }
  }

  // Opening and closing
  // popupLastSeen -> last time the user has saw the popup
  // popupLastClosed -> last time the user has clicked the close icon
  let popupLastSeen = parseInt(localStorage.getItem('socialpopupLastSeen'), 10) || 0
  let popupLastClosed = parseInt(localStorage.getItem('socialpopupLastClosed'), 10) || 0
  const waitBeforeShowingAgain = 60 * 60 * 24 * 14 // 14 days
  const waitBeforeAutoClosingPopup = 250 // was 250
  const waitBeforeShowingPopup = 45 // was 30
  const waitBeforeReshowingPopup = 35 // was 20
  const waitBeforePageScrollPercent = 20
  let popupInitialized = false

  // Don't show popup if the user has closed recently
  if (
    getCurrentTimestamp() - popupLastClosed > waitBeforeShowingAgain &&
    window.location.pathname !== '/it/newsletter/'
  ) {
    // Show popup after X seconds
    setTimeout(() => {
      popupInit()
    }, waitBeforeShowingPopup * 1000)

    // Show popup after user has scrolled X% of page
    // const bodyHeight = document.body.scrollHeight
    // const scrollInterval = setInterval(() => {
    // 	if (window.scrollY > bodyHeight / waitBeforePageScrollPercent) {
    // 		popupInit()
    // 		clearInterval(scrollInterval)
    // 	}
    // }, 1000 / 15)

    // Show popup if this is not the first page visited
    const regexReferrer = /^(?:http|https):\/\/(www\.|)asiago\.it(?:.*?)$/gims
    if (regexReferrer.test(document.referrer)) {
      setTimeout(() => {
        popupInit()
      }, waitBeforeReshowingPopup * 1000)
    }
  }

  function popupInit() {
    // Init popup
    if (popupInitialized) {
      return
    }

    document.body.appendChild(popup)
    popupOpen()
    checkPopupSize()
    popupCountdown(waitBeforeAutoClosingPopup)
    popup.querySelector('.sp__popupclose .sp__closeicon').addEventListener('click', () => {
      localStorage.setItem('socialpopupLastClosed', getCurrentTimestamp())
      popupClose()
    })
    localStorage.setItem('socialpopupLastSeen', getCurrentTimestamp())

    popupInitialized = true
  }

  function popupCountdown(seconds) {
    const closecountdown = document.querySelector('.sp__closecountdown')
    let isMouseHover = false
    popup.addEventListener('mouseover', () => {
      isMouseHover = true
    })
    popup.addEventListener('mouseout', () => {
      isMouseHover = false
    })
    const countdownInterval = setInterval(() => {
      if (seconds <= 0) {
        clearInterval(countdownInterval)
        localStorage.setItem('socialpopupLastSeen', getCurrentTimestamp())
        popupClose()
      }

      if (!isMouseHover) {
        // Paused while mouse is over
        closecountdown.textContent = seconds
        seconds--
      }
    }, 1000)
  }

  function popupOpen() {
    popup.classList.remove('socialpopupSlideOut')
    popup.classList.add('socialpopupSlideIn')

    // Facebook like requires re-initialization since the element was hidden until now
    if (typeof FB != 'undefined' && FB != null) {
      if (popup.querySelector('.fb-like').innerHTML == '') {
        FB.XFBML.parse(popup)
      }
    } else {
      popup.querySelector('.fb-like').remove()
    }
  }

  function popupClose() {
    popup.classList.remove('socialpopupSlideIn')
    popup.classList.add('socialpopupSlideOut')
  }

  // Handling resize & making sure the popup isn't taller than window height
  window.addEventListener('resize', checkPopupSize)
  function checkPopupSize() {
    const shortClass = 'socialpopup--short'
    let data = {
      windowHeight:
        window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
      windowWidth:
        window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
      popupHeight: popup.clientHeight,
      popupMargin: 8,
    }

    if (popup.classList.contains(shortClass)) {
      // Adding the potential picture height to prevent flickering
      data.popupHeight += data.windowWidth >= 480 ? 180 : 160
    }

    if (data.windowHeight < data.popupHeight + data.popupMargin * 2) {
      popup.classList.add(shortClass)
    } else {
      popup.classList.remove(shortClass)
    }
  }
  // setTimeout(checkPopupSize, 1000)
  // setTimeout(checkPopupSize, 2000)
  // setTimeout(checkPopupSize, 3000)
  // setTimeout(checkPopupSize, 4000)
  // setTimeout(checkPopupSize, 5000)

  // Generic functions
  function getCurrentTimestamp(milliseconds = false) {
    const ts = new Date().getTime()

    return milliseconds ? ts : parseInt(ts / 1000, 10)
  }
}

window.socialpopup = socialpopup
